<template>
  <button
    v-if="isLoggedIn"
    name="buy"
    type="button"
    class="btn btn-lg btn-block"
    :disabled="disabled"
    @click="$emit('buy')"
  >
    <slot />
  </button>
  <button
    v-else
    type="button"
    name="login"
    class="btn btn-lg btn-block"
    @click="login"
  >
    {{ $t('navbar.login') }}
  </button>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: ['disabled'],
  computed: {
    ...mapGetters('session', ['isLoggedIn']),
  },
  methods: {
    ...mapMutations('session', ['redirectAfterLogin']),

    login() {
      this.redirectAfterLogin(this.$route.fullPath);
      this.$router.push({ name: `login-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
    },
  },
};
</script>
